import { styled } from "@mui/material/styles";

export const StyledLoadMoreWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  marginTop: "32px"
}));

export const StyledReadMoreSpan = styled("span")(({ theme }) => ({
  marginTop: "12px"
}));
